module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "fileModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n        Send a fichier\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "file",
      "id": "file"
    },
    on: {
      "change": _vm.addFile
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black deny button"
  }, [_vm._v("\n            Cancel\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ui right green labeled icon button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendFile($event)
      }
    }
  }, [_vm._v("\n            Send\n            "), _c('i', {
    staticClass: "checkmark icon"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui header"
  }, [_vm._v("Choice a fichier "), _c('em', [_vm._v("( jpg, png, 1 mb max )")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b3ddde8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/FileModal.vue
// module id = 226
// module chunks = 1